var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 42,
    viewBox: "0 0 66 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5129 8.51475C57.3196 10.8834 63.3522 18.0138 65.0176 21.283C65.0176 29.055 50.0288 34.7915 47.068 35.1616C42.2568 40.898 39.6661 41.2681 37.2605 40.898C34.8549 40.5279 35.5951 37.012 35.5951 35.1616C34.5588 35.1616 31.2156 34.1747 29.6736 33.6812C28.1315 35.2233 24.6033 37.9373 22.8268 36.4569C21.0503 34.9765 21.0997 31.3989 21.3464 29.7952C20.853 29.4251 19.0148 28.0928 15.61 25.7242C11.724 30.9055 5.2473 32.0158 4.13702 31.2756C3.02673 30.5354 4.69218 27.3896 4.87722 23.3185C5.06227 19.2475 -0.304104 15.3615 1.73142 14.6213C6.91274 12.5488 13.1427 16.5952 15.61 18.8774C16.1034 18.6307 17.5715 17.6931 19.496 15.9166C22.0126 13.4 26.3427 11.0437 28.1932 10.1802C27.3296 7.89792 26.0096 3.07435 27.638 2.03809C41.8867 -1.29276 43.9222 4.07361 46.5129 8.51475Z",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6942 10.1802C50.7052 12.2643 49.4896 16.3429 49.4097 21.2831M51.6942 33.3111C49.9229 29.1359 49.3501 24.9696 49.4097 21.2831M45.7727 8.69984C42.1951 8.39142 33.7816 7.88563 28.7484 9.81012M25.4175 12.5859C25.0042 14.4933 24.5057 17.7674 24.3831 21.2831M25.4175 30.9055C24.4849 28.1077 24.2679 24.5886 24.3831 21.2831M21.9016 29.9803C22.8885 30.7205 25.6396 32.4229 28.7484 33.3111M36.1503 34.9766C37.8774 35.285 42.3679 35.7168 46.5129 34.9766M24.3831 21.2831H49.4097",
    stroke: "#03422F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.7cf137e3dacf10855db5963e43f77a68.svg";
export { ForwardRef as ReactComponent };